module.exports = __webpack_public_path__ + "img/36.d9a2b63c.svg";